const template = document.createElement('template')
template.innerHTML = `
  <style>
    :host { display: contents; }
    dialog {
      width: min(calc(100vw - 2 * var(--space-4)), 22rem);
      box-sizing: border-box;
      padding: 0;
      border: var(--border-width) solid var(--color-border);
      border-radius: var(--radius-md);
      background: var(--color-surface);
      color: var(--color-text);
    }
    dialog::backdrop {
      background: rgb(0 0 0 / 0.4);
    }
    form {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
      padding: var(--space-4);
    }
    h2 {
      margin: 0;
      font-size: 1.125rem;
      font-weight: var(--font-weight-bold);
    }
    label {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
      color: var(--color-text-secondary);
      font-size: var(--font-size-sm);
    }
    input {
      height: var(--control-height);
      box-sizing: border-box;
      padding: 0 var(--space-3);
      border: var(--border-width) solid var(--color-border);
      border-radius: var(--radius-sm);
      background: var(--color-input);
      color: var(--color-text);
      font: inherit;
    }
    input:focus {
      outline: none;
      border-color: var(--color-accent);
    }
    button {
      height: var(--control-height);
      padding: 0 var(--space-4);
      border: none;
      border-radius: var(--radius-sm);
      background: var(--color-accent-strong);
      color: var(--color-text-on-accent);
      font: inherit;
      font-weight: var(--font-weight-bold);
      cursor: pointer;
    }
  </style>
  <dialog>
    <form method="dialog">
      <h2>Join as guest</h2>
      <label>
        Your name
        <input name="name" required maxlength="64" autocomplete="name">
      </label>
      <button>Join</button>
    </form>
  </dialog>
`

// Where the name is remembered for next time.
const storageKey = 'meat:name'

/**
 * Asks for the name to join the meeting as, then fires `join` with it. The
 * name is remembered, so next time it only needs confirming.
 */
export class MeatJoin extends HTMLElement {
  #dialog: HTMLDialogElement
  #input: HTMLInputElement

  constructor() {
    super()
    const root = this.attachShadow({ mode: 'open' })
    root.append(template.content.cloneNode(true))
    this.#dialog = root.querySelector('dialog')!
    this.#input = root.querySelector('input')!

    // There's no joining without a name, so Escape doesn't dismiss it.
    this.#dialog.addEventListener('cancel', e => e.preventDefault())
    root.querySelector('form')!.addEventListener('submit', e => {
      const name = this.#input.value.trim()
      if (!name) {
        e.preventDefault()
        this.#input.value = ''
        this.#input.reportValidity()
        return
      }
      localStorage.setItem(storageKey, name)
      this.dispatchEvent(new CustomEvent('join', { detail: name, bubbles: true }))
    })
  }

  connectedCallback() {
    this.#input.value = localStorage.getItem(storageKey) ?? ''
    if (!this.#dialog.open) this.#dialog.showModal()
    this.#input.select()
  }
}

customElements.define('meat-join', MeatJoin)

declare global {
  interface HTMLElementTagNameMap {
    'meat-join': MeatJoin
  }
  interface HTMLElementEventMap {
    join: CustomEvent<string>
  }
}
